import moment from "moment";
import _ from "lodash";

var commonJson ={
	"type": "day",
	"placeholder": moment().format("YYYY-MM-DD"),
	"inputStyle": {
        "display": "inline-block",
        "line-height": "22px",
        "font-size": "16px",
        "border": "none",
        "background":"none",
        "text-align":"center",
        "width":"100%"
	},
	"format": "YYYY-MM-DD",
}
var enJSON = {
	"week": ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
	"month": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	"buttons": {
      ok: 'Ok',
      cancel: 'Cancel'
    },
}

var zhJSON = {
	"week": ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
	"month": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
	"buttons": {
      ok: '确定',
      cancel: '取消'
    },


}
var lan = localStorage.language || "zh_CN" ;
var json = lan=="en_US" ? enJSON : zhJSON

export default _.merge({},commonJson,json)




// WEBPACK FOOTER //
// ./src/conf/datePick.js